module.exports = __webpack_public_path__ + "static/media/11b.22d0b36a.svg";